// extracted by mini-css-extract-plugin
export var backgroundCoverCenter = "textAndImage-module--background-cover-center--1smpu";
export var backgroundCoverTop = "textAndImage-module--background-cover-top--1I7So";
export var backgroundContainTop = "textAndImage-module--background-contain-top--1TmQi";
export var backgroundContainCenter = "textAndImage-module--background-contain-center--_97Dg";
export var backgroundContainLeft = "textAndImage-module--background-contain-left--2epzE";
export var section = "textAndImage-module--section--3X7Q7";
export var image = "textAndImage-module--image--XUDQb";
export var right = "textAndImage-module--right--27nOV";